import React, {useEffect, useMemo, useState} from 'react';
import FormContentLoader from '../../../components/FormContentLoader';
import ENDPOINT from '../../../constants/endpoints';
import useApi from '../../../hooks/useApi';

const HelloPage = ({location, match, updateState, clearSavedState, ...props}) => {
  const api = useApi();
  const [school, setSchool] = useState(null);
  const [loading, setLoading] = useState(true);
  const schoolAcronym = useMemo(() => {
    return match.params.school;
  }, [match]);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    clearSavedState();

    api.getRequest(ENDPOINT.STUDENT.SCHOOL, {school: schoolAcronym})
      .then((response) => {
        if (response.status !== 'OK') {
          throw response;
        }

        setSchool(response.data);
        updateState({
          data: {
            school: response.data,
          },
          canContinue: true,
        });
        setLoading(false)
      })
      .catch(() => {
        props.history.replace('/student/school');
      });
  }, []);

  return (
    <div>
      {loading && <FormContentLoader/>}
      {!loading && school && (
        <div className={'student-school'}>
          <div className={'student-school__header'}>
            <h1>{school.shortName || school.name}</h1>
            {!!school.logo && (
              <img width={64} height={64} src={school.logo} alt={school.name}/>
            )}
            {!!school.fullLogo && !school.logo && (
              <img width={250} height={64} src={school.fullLogo} alt={school.name}/>
            )}
          </div>
          <div className={'student-school__content'}>
            <h2 className={'student-school__title'}>Welcome!</h2>
            <p className={'student-school__subtitle'}>Graduating class of {currentYear}</p>
            <div className={'student-school__description'}>
              <p>
                Welcome, recent graduates from {school.shortName || school.name}.
                As you launch your careers, we encourage you to join numerous {school.shortName || school.name} alums in finance by creating a GoBuyside profile. GoBuyside's
                goal is to provide recruiting resources as you build your finance career – beginning with interview prep materials and access to top
                PE Associate jobs, and continuing as you build your finance career with resources such as compensation studies and access to future
                finance roles.
              </p>
              <p>
                Please click below to register with us. Thanks!
              </p>
              <p>
                The GoBuyside Team
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HelloPage;
